import React from 'react';
import { SketchToolProvider } from './context';
import SketchTool from './SketchTool';
export default props => (
  <SketchToolProvider>
    <SketchTool {...props} />
  </SketchToolProvider>
);
